
export default function tabs() {
    const tabsContainer = document.querySelector('.js-tabs');

    if (!tabsContainer) {
        return null;
    }

    tabsContainer.addEventListener('click', (e) => {
        const button = e.target.closest('.js-tabs-button');

        if (!button) {
            return null;
        }

        const tabId = button.dataset.tab;

        if (!tabId) {
            return null;
        }
        
        const buttons = tabsContainer.querySelectorAll('.js-tabs-button');
        const panels = tabsContainer.querySelectorAll('.js-tabs-panel');

        buttons.forEach(btn => btn.classList.remove('active'));
        panels.forEach(panel => panel.classList.remove('active'));

        button.classList.add('active');
        
        const panel = tabsContainer.querySelector(`.js-tabs-panel[data-tab-content="${tabId}"]`);
        if (panel) {
            panel.classList.add('active');
        }
    });
}


// WEBPACK FOOTER //
// ./_layout/js/tabs.js